import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
const document_API = "https://notregrandbleu.herokuapp.com/document/";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" })
};
@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  public AfficherDocument(): Observable<any> {
    return this.http.get(document_API , httpOptions);
  }

  addDocument(document): Observable<any> {
    return this.http.post(document_API + "addDocument", document ,httpOptions );
  }
  deleteDocument(id): Observable<any> {
    return this.http.get(document_API + "supprimer/"+ id ,httpOptions );
  }
  modify(document):Observable<any>
  {
    return this.http.put(document_API+ "modifier" ,  document , httpOptions );
  }

  constructor(private http: HttpClient) { }
}
